import { Component } from '@angular/core';
import { AuthService } from '../../../Shared/Services/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { environment } from '../../../../environments/environment'
import { GalleryService } from '../../../Services/gallery.service';
import { CustomToastrService } from '../../../Shared/Services/custom-toastr.service';
import { DtoCategoryGalleryViewModalVM } from '../../../Model/gallery/DtoCategoryGalleryViewModalVM';
import { Router } from '@angular/router';
import { DtoChildCategoryGalleryVM } from '../../../Model/gallery/DtoChildCategoryGalleryVm';
import { SharedService } from '../../../Shared/Services/shared.service';
import { ShowImageComponent } from '../../../Shared/Components/show-image/show-image.component';
import { DialogService } from '../../../Shared/Services/dialog.service';

@Component({
  selector: 'app-gallery',
  templateUrl: './gallery.component.html',
  styleUrl: './gallery.component.scss'
})
export class GalleryComponent {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  imgPath: string = environment.ImgUrl;
  AllCategoryGallery: DtoCategoryGalleryViewModalVM[] = [];
  OriginalCategoryGallery!: DtoCategoryGalleryViewModalVM[];
  selectedCategory?: DtoCategoryGalleryViewModalVM | null = null;
  GalleriesList!: DtoChildCategoryGalleryVM[];
  constructor(private api: GalleryService, private auth: AuthService, private spinner: NgxSpinnerService,
    private toastrService: CustomToastrService, private router: Router, private shared: SharedService,
    private dialogService: DialogService) { }

  ngOnInit() {
    if (this.auth.isAuthenticated()) {
      this.spinner.show();
      this.GetAllCategoryGallery();
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  GetAllCategoryGallery() {
    if (this.auth.isAuthenticated()) {
      this.api.GetAllCategoryGallery()
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          {
            next: (res: any) => {
              this.AllCategoryGallery = res.payload;
              this.OriginalCategoryGallery = res.payload;
              this.AllCategoryGallery.map((a: DtoCategoryGalleryViewModalVM) => {
                if (this.selectedCategory == null) {
                  this.selectedCategory = a;
                  this.ShowGalleries(a);
                }
              });
              this.spinner.hide();
            },
            error: (error: any) => {
              this.spinner.hide();
              this.toastrService.showErrorToast('Error', "SomethingWentWrong");
            }
          });
    } else {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
  }

  ShowGalleries(CategoryGallery: any) {
    this.GalleriesList = CategoryGallery.listGallery;
    this.selectedCategory = CategoryGallery.name;
  }

  checkSearchVal(searchVal?: any) {
    this.AllCategoryGallery = this.shared.checkSearchVal(this.AllCategoryGallery, this.OriginalCategoryGallery, searchVal, 'categoryName');
  }

  ShowImage(gallery?: any) {
    const data = { 'title': gallery.description, 'pathImage': this.imgPath + "/" + gallery.pathImage };
    this.dialogService.openDialog(ShowImageComponent, data);
  }
}
